import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';

export const AUTH_TOKEN_KEY = 'authToken';
export const LAST_ACTIVITY_KEY = 'lastActivity';
export const SESSION_ID_KEY = 'sessionId';
export const DEVICE_ID_KEY = 'pear.deviceId';

export const getDeviceIdCookie = (): string => {
  const name = `${DEVICE_ID_KEY}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookies = decodedCookie.split(';');

  for (let i = 0; i < cookies.length; i++) {
    let c = cookies[i].trimStart();
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

export const saveDeviceIdCookie = (): string => {
  const date = new Date();
  date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  const deviceId = uuidv4();
  document.cookie = `${DEVICE_ID_KEY}=${deviceId};${expires};path=/`;
  return deviceId;
};

const save = (key: string, value: string | number): void => {
  window.sessionStorage.setItem(key, value as string);
};

const load = (key: string): Nullable<string> =>
  window.sessionStorage.getItem(key);

const clear = (key: string): void => {
  window.sessionStorage.removeItem(key);
};

export const saveAuthToken = (token: string): void => {
  save(AUTH_TOKEN_KEY, token);
};

export const loadAuthToken = (): Nullable<string> => load(AUTH_TOKEN_KEY);

export const clearAuthToken = (): void => {
  clear(AUTH_TOKEN_KEY);
};

export const saveLastActivity = (): void => {
  save(LAST_ACTIVITY_KEY, moment().valueOf());
};

export const loadLastActivity = (): Nullable<string> => load(LAST_ACTIVITY_KEY);

export const clearLastActivity = (): void => {
  clear(LAST_ACTIVITY_KEY);
};

export const saveSessionId = (): void => {
  const uuid = uuidv4();
  save(SESSION_ID_KEY, uuid);
};

export const loadSessionId = (): Nullable<string> => load(SESSION_ID_KEY);

export const clearSessionId = (): void => {
  clear(SESSION_ID_KEY);
};

export const clearTokenStorage = (): void => {
  clearAuthToken();
  clearLastActivity();
  clearSessionId();
};
